<script setup>
  const consentStore = useConsentStore()
  const localePath = useLocalePath()
  const { t, tm, rt, locale } = useI18n()
</script>

<template>
  <Transition name="fade-slide-up">
    <div v-if="consentStore.bannerVisible && consentStore.ready" class="fixed bottom-4 inset-x-0 z-[900] px-4">
      <div
        class="mx-auto max-w-5xl bg-white/97 border border-slate-200 shadow-2xl shadow-slate-900/50 rounded-2xl p-4 md:p-6 flex flex-col gap-4 max-h-[80vh] overflow-y-auto"
      >
        <!-- <div class="space-y-4 text-sm text-slate-700 leading-relaxed">
          <p class="text-lg font-bold text-slate-900">
            {{ t('consent.title') }}
          </p>

          <p>{{ t('consent.intro') }}</p>

          <div>
            <p class="font-bold mb-1">{{ t('consent.purposes.title') }}</p>
            <ul class="list-disc pl-5 space-y-1">
              <li v-for="(item, index) in tm('consent.purposes.items')" :key="index">
                {{ rt(item) }}
              </li>
            </ul>
          </div>

          <p>{{ t('consent.acceptAllIntro') }}</p>

          <ul class="list-disc pl-5 space-y-2">
            <li v-for="(item, index) in tm('consent.acceptAllPurposes')" :key="index">
              <strong>{{ rt(item.title) }}</strong> {{ rt(item.description) }}
            </li>
          </ul>

          <p>{{ t('consent.rejectAllIntro') }}</p>
          <p>{{ t('consent.settingsIntro') }}</p>
          <p>{{ t('consent.impactIntro') }}</p>
          <p>{{ t('consent.retention') }}</p>

          <p>
            {{ t('consent.policy.text') }}
            <NuxtLink
              :to="
                localePath({
                  name: 'pages-slug',
                  params: { slug: 'politique-de-protection-des-donnees' }
                })
              "
              class="text-sky-700 hover:text-sky-600 underline"
            >
              {{ t('consent.policy.link') }}
            </NuxtLink>
          </p>
        </div> -->

        <div class="flex items-center gap-3 mb-2">
          <div
            class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-sky-100 to-sky-200 rounded-xl flex items-center justify-center shadow-sm"
          >
            <font-awesome :icon="['fas', 'cookie-bite']" class="text-sky-700 text-2xl" />
          </div>
          <p class="text-lg font-bold text-slate-900">{{ t('consentCookie.title') }}</p>
        </div>

        <div class="space-y-4 text-sm text-slate-700 leading-relaxed">
          <p>{{ t('consentCookie.intro') }}</p>

          <div>
            <p class="font-bold mb-1" v-html="t('consentCookie.acceptAllIntro')"></p>
            <ul class="list-disc pl-5 space-y-1">
              <li v-for="(purpose, index) in tm('consentCookie.acceptAllPurposes')" :key="index">
                {{ rt(purpose) }}
              </li>
            </ul>
          </div>

          <p v-html="t('consentCookie.rejectAllIntro')"></p>

          <p v-html="t('consentCookie.settingsIntro')"></p>

          <p>
            {{ t('consentCookie.impactIntro') }}
          </p>

          <p>
            {{ t('consentCookie.policy.text') }}
            <NuxtLink
              :to="localePath({ name: 'pages-slug', params: { slug: 'politique-de-protection-des-donnees' } })"
              target="_blank"
              class="font-bold text-sky-700 hover:text-sky-600 underline"
            >
              {{ t('consentCookie.policy.link') }} </NuxtLink
            >.
          </p>
        </div>

        <div class="flex flex-col md:flex-row gap-2 pt-4 border-t border-slate-200">
          <button
            class="flex-1 rounded-lg bg-slate-100 text-slate-800 border border-slate-200 px-4 py-2.5 text-sm font-semibold hover:bg-slate-200 transition-colors cursor-pointer"
            @click="consentStore.rejectAll()"
          >
            {{ t('consentCookie.rejectAll') }}
          </button>
          <button
            class="flex-1 rounded-lg bg-white text-sky-700 border border-sky-200 px-4 py-2 text-sm font-semibold hover:bg-sky-50 transition-colors cursor-pointer"
            @click="consentStore.openPreferences()"
          >
            {{ t('consentCookie.customize') }}
          </button>
          <button
            class="flex-1 rounded-lg bg-sky-700 text-white px-4 py-2.5 text-sm font-semibold hover:bg-sky-800 transition-colors cursor-pointer shadow-sm"
            @click="consentStore.acceptAll()"
          >
            {{ t('consentCookie.acceptAll') }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
